export default {
  id: 'registry',
  title: 'Companies, users and partnerships (admin)',
  note: 'The three registry screens of the operator panel: the carrier list and its onboarding form, the account list and its form, and the partnership agreements with their form.',
  texts: {
    // ── Companies ────────────────────────────────────────────────────────────
    'companies.crumb': 'Companies',
    'companies.title': 'Companies',
    'companies.subtitle': '{count} carriers registered · settling against the MAS platform',
    'companies.filter.resetTitle': 'Reset filters',
    'companies.filter.country': 'Country: All',
    'companies.action.export': 'Export',
    'companies.action.onboard': 'Onboard carrier',
    'companies.action.remove': 'Remove',
    'companies.searchPlaceholder': 'Search company name, RICS, country…',
    'companies.countOf': '{shown} of {total}',
    'companies.empty.none': 'No companies registered yet. Click "Onboard carrier" to add the first one.',
    'companies.empty.search': 'No companies match your search.',
    'companies.confirmDelete': 'Delete this company?',
    'companies.modal.edit': 'Edit Company',
    'companies.modal.create': 'Onboard new carrier',
    'companies.csv.id': 'ID',
    'companies.csv.name': 'Name',
    'companies.csv.rics': 'RICS',
    'companies.csv.country': 'Country',
    'companies.csv.type': 'Type',
    'companies.csv.status': 'Status',

    'companies.form.companyId.label': 'Company ID (URN)',
    'companies.form.companyId.placeholder': 'urn:uic:rics:1185:000001 or ngrs:00023',
    'companies.form.companyId.hint': 'Company ID is immutable after creation',
    'companies.form.name.label': 'Company Name',
    'companies.form.name.placeholder': 'e.g. PKP Intercity',
    'companies.form.rics.label': 'RICS Code',
    'companies.form.rics.placeholder': '4-digit numeric (e.g. 5151)',
    'companies.form.country.label': 'Country',
    'companies.form.description.label': 'Description',
    'companies.form.description.placeholder': 'Optional notes about the carrier (operating area, services, etc.)',
    'companies.form.saving': 'Saving…',
    'companies.form.save': 'Save changes',
    'companies.form.create': 'Create company',

    // Country names only — the two-letter code next to each one is the value
    // stored on the company and must not be edited here.
    'companies.form.country.at': 'Austria',
    'companies.form.country.be': 'Belgium',
    'companies.form.country.bg': 'Bulgaria',
    'companies.form.country.ch': 'Switzerland',
    'companies.form.country.cz': 'Czech Republic',
    'companies.form.country.de': 'Germany',
    'companies.form.country.dk': 'Denmark',
    'companies.form.country.es': 'Spain',
    'companies.form.country.fi': 'Finland',
    'companies.form.country.fr': 'France',
    'companies.form.country.gb': 'United Kingdom',
    'companies.form.country.gr': 'Greece',
    'companies.form.country.hr': 'Croatia',
    'companies.form.country.hu': 'Hungary',
    'companies.form.country.it': 'Italy',
    'companies.form.country.lu': 'Luxembourg',
    'companies.form.country.nl': 'Netherlands',
    'companies.form.country.no': 'Norway',
    'companies.form.country.pl': 'Poland',
    'companies.form.country.pt': 'Portugal',
    'companies.form.country.ro': 'Romania',
    'companies.form.country.se': 'Sweden',
    'companies.form.country.si': 'Slovenia',
    'companies.form.country.sk': 'Slovakia',
    'companies.form.country.tr': 'Turkey',

    // ── Users ────────────────────────────────────────────────────────────────
    'users.crumb': 'Users',
    'users.title': 'Users',
    'users.subtitle': '{count} accounts across {companies} companies',
    'users.action.export': 'Export',
    'users.action.new': 'New user',
    'users.tab.all': 'All',
    'users.tab.admins': 'Admins',
    'users.tab.users': 'Users',
    'users.searchPlaceholder': 'Search username, email, name…',
    'users.countOf': '{shown} of {total}',
    'users.loading': 'Loading…',
    'users.empty': 'No users.',
    'users.confirmDelete': 'Delete this user?',
    'users.modal.edit': 'Edit user',
    'users.modal.create': 'Create new user',
    'users.table.username': 'Username',
    'users.table.name': 'Name',
    'users.table.email': 'Email',
    'users.table.company': 'Company',
    'users.table.role': 'Role',
    'users.table.status': 'Status',
    'users.table.actions': 'Actions',
    'users.status.active': 'active',
    'users.status.disabled': 'disabled',
    'users.csv.id': 'ID',
    'users.csv.username': 'Username',
    'users.csv.firstName': 'First name',
    'users.csv.lastName': 'Last name',
    'users.csv.email': 'Email',
    'users.csv.role': 'Role',
    'users.csv.company': 'Company',
    'users.csv.rics': 'RICS',
    'users.csv.status': 'Status',

    'users.form.username.label': 'Username',
    'users.form.email.label': 'Email',
    'users.form.company.label': 'Company',
    'users.form.company.placeholder': 'Select a company',
    'users.form.role.label': 'Role',
    // Role names only — the stored role (USER / ADMIN / MANAGER) is unaffected.
    'users.form.role.user': 'User',
    'users.form.role.admin': 'Admin',
    'users.form.role.manager': 'Manager',
    'users.form.enabled.label': 'Active',
    'users.form.saving': 'Saving...',
    'users.form.submit': 'Save User',

    // ── Partnerships ─────────────────────────────────────────────────────────
    'partnerships.crumb': 'Partnerships',
    'partnerships.title': 'Partnerships',
    'partnerships.subtitle': '{count} agreements between carriers · settlement rules per agreement',
    'partnerships.action.export': 'Export',
    'partnerships.action.new': 'New agreement',
    'partnerships.tab.all': 'All',
    'partnerships.tab.active': 'Active',
    'partnerships.tab.pending': 'Pending',
    'partnerships.tab.inactive': 'Inactive',
    'partnerships.searchPlaceholder': 'Search agreement ID, name, type…',
    'partnerships.countOf': '{shown} of {total}',
    'partnerships.loading': 'Loading…',
    'partnerships.empty.none': 'No partnership agreements yet. Click "New agreement" to create the first one.',
    'partnerships.empty.filter': 'No agreements match the filter.',
    'partnerships.confirmDelete': 'Delete this partnership?',
    'partnerships.modal.edit': 'Edit agreement',
    'partnerships.modal.create': 'New partnership agreement',
    'partnerships.table.agreementId': 'Agreement ID',
    'partnerships.table.name': 'Name',
    'partnerships.table.type': 'Type',
    'partnerships.table.status': 'Status',
    'partnerships.table.start': 'Start',
    'partnerships.table.end': 'End',
    'partnerships.table.actions': 'Actions',
    'partnerships.csv.id': 'ID',
    'partnerships.csv.agreementId': 'Agreement ID',
    'partnerships.csv.type': 'Type',
    'partnerships.csv.status': 'Status',
    'partnerships.csv.frequency': 'Frequency',
    'partnerships.csv.start': 'Start',
    'partnerships.csv.end': 'End',
    'partnerships.csv.members': 'Members',

    'partnerships.form.agreementId.label': 'Agreement ID *',
    'partnerships.form.agreementId.placeholder': 'urn:hitrail:agreement:my-agreement',
    'partnerships.form.name.label': 'Name *',
    'partnerships.form.name.placeholder': 'Human-readable agreement name',
    'partnerships.form.type.label': 'Partnership Type *',
    'partnerships.form.status.label': 'Status *',
    'partnerships.form.startDate.label': 'Start date',
    'partnerships.form.endDate.label': 'End date',
    'partnerships.form.description.label': 'Description',
    'partnerships.form.description.placeholder': 'Optional notes about the agreement',
    'partnerships.form.members.label': 'Member Companies',
    'partnerships.form.members.counter': '{selected} of {total} selected',
    'partnerships.form.members.searchPlaceholder': 'Search by name, RICS or country code…',
    'partnerships.form.members.clearAll': 'Clear all',
    'partnerships.form.members.noMatch': 'No companies match "{query}"',
    'partnerships.form.saving': 'Saving…',
    'partnerships.form.submit': 'Save Partnership',

    // Type and status names only — the values sent to the API (BILATERAL,
    // ACTIVE, …) are enum members and stay as they are.
    'partnerships.form.type.bilateral': 'Bilateral',
    'partnerships.form.type.multilateral': 'Multilateral',
    'partnerships.form.type.revenueSharing': 'Revenue sharing',
    'partnerships.form.type.servicesAgreement': 'Services agreement',
    'partnerships.form.type.dataSharing': 'Data sharing',
    'partnerships.form.status.pending': 'Pending',
    'partnerships.form.status.active': 'Active',
    'partnerships.form.status.terminated': 'Terminated',
    'companies.error.load': 'Failed to load companies',
    'companies.error.save': 'Failed to save company',
    'companies.error.delete': 'Failed to delete',
    'users.error.load': 'Failed to load users',
    'users.error.save': 'Failed to save user',
    'users.error.delete': 'Failed to delete',
    'partnerships.error.load': 'Failed to load partnerships',
    'partnerships.error.save': 'Failed to save',
    'partnerships.error.delete': 'Failed to delete',
  },
}
